// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2MSev","selected":"Chip_selected__2_woC"};